module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/bullet-list-d032554397aa248e88d18647abb03230.svg";